module.exports = __webpack_public_path__ + "static/merch4Front-65766281f9e85cc92565fa11861395b3.png";